// функция принимает название иконки из макета в Figma и возвращает название компонента иконки
// Примеры:
// link-broken-01 --> LinkBroken1Icon
// info-square --> InfoSquareIcon
// cloud-blank-02 --> CloudBlank2Icon
// x --> XIcon

export function getIconComponentName(icon: string | undefined): string {
  if (!icon) {
    return ''
  }

  const words = icon.split('-')
  let iconComponentName = ''

  if (words.length > 1) {
    for (let i = 0; i < words.length; i++) {
      const word = words[i]
      if (!isNaN(+word)) {
        iconComponentName += parseInt(word)
      } else {
        iconComponentName += word.charAt(0).toUpperCase() + word.slice(1)
      }
    }
  } else {
    iconComponentName = icon
  }

  return iconComponentName
}
